import { http } from '../axios';
import { BundleResponseOut } from '../../store/api';
import { shopPrefix } from '../../config';

type Params = {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    category?: string;
    ageCategory?: string;
    includeProducts?: boolean;
    loanFormat?: string;
    shopLanguage: string | undefined;
};

const url = `${shopPrefix}/v1/bundles/:loanFormat`;

export const fetchBundles = ({ loanFormat, ...params }: Params) => {
    return http.get<BundleResponseOut>(url, { pathParams: { loanFormat }, params }).then(res => res.data);
};
